export const replaceLocation = (url: string) => {
  window.location.replace(url);
};
